import styled from 'styled-components';

import Box from '../Box';
import Button from '../Button';

export const SearchIconButton = styled(Button)`
  z-index: 1;
  position: absolute;
  font-size: 24px;
  left: 0;
  right: 0;
  margin: 0 auto;
  background: 0;
  padding: 0;
  border: none;
  color: ${({ theme }) => theme.colors.blue[50]};
  cursor: pointer;
  width: 32px;
  height: 32px;
  margin-top: -4px;
  top: 0;
`;

export const CloseIconButton = styled(Button)`
  z-index: 0;
  position: absolute;
  color: ${({ theme }) => theme.colors.grey[80]};
  font-size: 24px;
  left: auto;
  right: 0;
  margin: 0 auto;
  opacity: 0;
  background: 0;
  padding: 0;
  border: none;
  cursor: pointer;
  width: 32px;
  height: 32px;
  margin-top: -4px;
  top: 0;
  transition: 250ms ease;
`;

export const Wrapper = styled(Box)`
  box-sizing: border-box;
  position: relative;
  transform-origin: 100% 50%;
  width: 24px;
  height: 40px;
  cursor: pointer;
  transition: 250ms ease;
  text-align: right;
  height: 24px;

  &.focused {
    width: 100%;

    input {
      box-sizing: border-box;
      padding-right: 32px;
      padding-left: 32px;
      width: 100%;
      max-width: unset;
    }

    ${SearchIconButton} {
      left: 0;
      right: auto;
      margin-left: 0;
      margin-right: 0;
      pointer-events: none;
    }

    ${CloseIconButton} {
      opacity: 1;
      right: 0;
      left: auto;
    }
  }
`;

export const Input = styled.input`
  box-sizing: border-box;
  background: transparent;
  border: 0;
  outline: none;
  height: 24px;
  width: 0;
  overflow: hidden;
  font-weight: 100;
  padding: 0;
  max-width: 0%;
  transform-origin: 0 50%;
  transition: 250ms ease;
  border: none;
  border-bottom: 1px solid ${({ theme }) => theme.colors.blue[50]};
  font-size: 16px;
  margin-top: 4px;
  padding-bottom: 8px;
`;
